import { BasketItem } from '../../../types/basket';
import { Basket } from '../../../utils/checkoutState';

export const isMainItem = (item: BasketItem) => !item.itemGroup || item.itemGroup.isMainItem;

const groupItems = (items: BasketItem[], basketTotal: Basket['total']) => {
  const subItems = items
    .filter(item => !isMainItem(item))
    .reduce((itemGroups, item) => {
      if (!(item.itemGroup!.id in itemGroups)) {
        itemGroups[item.itemGroup!.id] = [];
      }
      itemGroups[item.itemGroup!.id].push(item);
      return itemGroups;
    }, {});

  const mainItemsWithSubItems = items.filter(isMainItem).map(mainItem => ({
    ...mainItem,
    ...(mainItem.itemGroup?.id && {
      subItems: subItems[mainItem.itemGroup.id],
      groupTotal: basketTotal.itemGroups![mainItem.itemGroup.id]
    })
  }));

  return mainItemsWithSubItems;
};

export default groupItems;
